var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgAge = function SvgAge(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 12 5.153 3.638A2 2 0 0 1 18 17.272V18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-.728a2 2 0 0 1 .847-1.634zm0 0 5.153-3.638A2 2 0 0 0 18 6.728V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v.728a2 2 0 0 0 .847 1.634z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M17.5 8h-11"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAge);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;